import React from 'react';
import './BlogSection.scss';
import Container from 'reactor/components/Grid/ContainerWithWidth';
import Link from "reactor/components/Link";
import BoxItem from 'reactor/components/Box';
import Image from 'reactor/components/Image';
import Slider from "react-slick";
import MoreLink from "./../../components/MoreLink";
import Heading from './../../components/heading';
import ArrowDiagonalDown from './../../components/ArrowDiagonalDown'

// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import artArtisticArtsy from 'assets/images/art-artistic-artsy.png'
import Aerial from 'assets/images/aerial-shot-basketball-court-color.png'
import Adult from 'assets/images/adult-adventure-aircraft.png'
import ArtColor from 'assets/images/art-colors-culture.png'
import ArtBrazil from 'assets/images/art-brazil-downtown.png'
import Audience from 'assets/images/audience-crowd-holi.png'

var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    rtl: true,
    rows: 2,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
    ],
};
const BlogItems = [ 
    {
        id: 1,
        title: 'فن الجرافيتي في بلاد الفرنجة',
        href: '‎',
        cat: 'فنون',
        img: artArtisticArtsy
    },
    {
        id: 2,
        title: 'كيف تؤثر استراتيجيات البحث قبل بناء العلامة التجارية',
        href: '‎',
        cat: 'UX-RE-SEARCH',
        img: Aerial
    },
    {
        id: 3,
        title: 'فوتو سيشن لغابات السافانامع HDR ',
        href: '‎',
        cat: 'فوتوغرافيا',
        img: Adult
    },
    {
        id: 4,
        title: 'تطبيقات تكنولوچيا النقل العام',
        href: '‎',
        cat: 'برمجة',
        img: ArtColor
    },
    {
        id: 5,
        title: 'الديكور فن اختيار الألوان كيف تستفيد من المساحة',
        href: '‎',
        cat: 'ألوان',
        img: ArtBrazil
    },
    {
        id: 6,
        title: 'كواليس هوية الجادة شاركونا آرائكم',
        href: '‎',
        cat: 'كواليس',
        img: Audience
    },
    {
        id: 7,
        title: 'فن الجرافيتي في بلاد الفرنجة',
        href: '‎',
        cat: 'فنون',
        img: Adult
    },
    {
        id: 8,
        title: 'تطبيقات تكنولوچيا النقل العام',
        href: '‎',
        cat: 'فنون',
        img: ArtColor
    },
    {
        id: 9,
        title: 'فن الجرافيتي في بلاد الفرنجة',
        href: '‎',
        cat: 'فنون',
        img: artArtisticArtsy
    },
    {
        id: 10,
        title: 'كيف تؤثر استراتيجيات البحث قبل بناء العلامة التجارية',
        href: '‎',
        cat: 'UX-RE-SEARCH',
        img: Aerial
    }
]

export default function Blog() {

    return (
        <div id="blog__section">
            <Container>
                <Heading title="رواديات"
                    subtitle="مدونتنا الحلوة .. مختارات في فلسفة التصميم"
                    notify="في البرمجة ، التكنولوچيا في المرح"
                />
            </Container>    
            <Slider {...settings}> 
            {/* <For array={BlogItems} render={BlogItem => ( */}
                { BlogItems.map( BlogItem => (
                <div key={BlogItem.id}>
                    <Link href={BlogItem.href}>
                        <BoxItem className="blog__item">
                            <div className="blog__item--image">
                                <Image src={BlogItem.img} alt={BlogItem.title} />
                            </div>
                            <BoxItem className="blog__item--caption" display="flex" justifyContent="space-between" flexDirection="column">
                                <BoxItem className="blog__item--category" display="flex" justifyContent="space-between"> 
                                    <BoxItem className="expand">
                                        <svg width="3.4rem" height="3.4rem" viewBox="0 0 34 34">
                                            <defs>
                                                <clipPath id="clip-path">
                                                <rect id="Rectangle_256" data-name="Rectangle 256" width="34" height="34" transform="translate(-114 3454)" fill="#fff" stroke="#707070" strokeWidth="1"/>
                                                </clipPath>
                                                <clipPath id="clip-path-2">
                                                <rect width="54.97" height="54.97" fill="none"/>
                                                </clipPath>
                                            </defs>
                                            <g id="Mask_Group_9" data-name="Mask Group 9" transform="translate(114 -3454)">
                                                <g id="Symbol_16_2" data-name="Symbol 16 – 2" transform="translate(-140.97 3458.718)">
                                                <path id="Path_259" data-name="Path 259" d="M1893.97,1353.5v13.126a2.5,2.5,0,0,1-2.5,2.5h0a2.5,2.5,0,0,1-2.5-2.5v-7.094l-15.8,15.8a2.5,2.5,0,1,1-3.534-3.533l15.8-15.8h-7.095a2.5,2.5,0,0,1,0-5h13.127a2.5,2.5,0,0,1,2.5,2.5Zm-34.443,28.411L1844,1397.439v-7.095a2.5,2.5,0,0,0-2.5-2.5h0a2.5,2.5,0,0,0-2.5,2.5v13.127a2.5,2.5,0,0,0,2.5,2.5h13.127a2.5,2.5,0,1,0,0-5h-7.093l15.528-15.528a2.5,2.5,0,0,0-3.534-3.534Z" transform="translate(-1839 -1351)" fill="#fff"/>
                                                </g>
                                            </g>
                                        </svg>
                                        <ArrowDiagonalDown color='#fff' />
                                    </BoxItem>
                                    <p className="blog__item--category--name">{BlogItem.cat}</p>
                                </BoxItem>
                                <h3>{BlogItem.title}</h3>
                            </BoxItem>
                        </BoxItem>
                    </Link>
                </div>
                ))}
               {/* ) } /> */}
            </Slider>   
            <Container block={"true"}>
                <MoreLink linkname="المزيد" />
            </Container>    
    
        </div>
    )
}